export { default as Home } from "./home/index";
export { default as Works } from "./works/index";
export { default as PetProjects } from "./petProject/index";
export { default as MainScreen } from "./mainScreen/index";
export { default as IDriverCase } from "./IDriverCase/index";
export { default as VoiceNotesCase } from "./VoiceNotesCase/index";
export { default as PlannerCase } from "./klokiCase/index";
